import React from "react";
import CustomerLayout from "../../layouts/UserLayout";
import LocationComponent from "../../components/LocationComponent";

import {
  Box,
  Flex,
  Heading,
  Text,
  IconButton,
  VStack,
  Spacer,
  Avatar,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiMenu, FiUser, FiLogOut, FiClock, FiMapPin } from "react-icons/fi";

const UserDashboard = () => {


  return (
    <CustomerLayout>

      <LocationComponent />

      <Flex minH="100vh" bg={useColorModeValue("gray.100", "gray.900")}>
      {/* Sidebar */}
      <Box
        w={{ base: "full", md: 60 }}
        bg={useColorModeValue("white", "gray.800")}
        p={5}
        display={{ base: "none", md: "block" }}
        shadow="md"
      >
        <VStack align="start" spacing={6}>
          <Heading size="md">My Dashboard</Heading>
          <Button leftIcon={<FiUser />} variant="ghost" w="full">
            Profile
          </Button>
          <Button leftIcon={<FiClock />} variant="ghost" w="full">
            Ride History
          </Button>
          <Button leftIcon={<FiMapPin />} variant="ghost" w="full">
            Book Ride
          </Button>
          <Spacer />
          <Button leftIcon={<FiLogOut />} colorScheme="red" variant="ghost" w="full">
            Logout
          </Button>
        </VStack>
      </Box>

      {/* Main Content */}
      <Box flex="1" p={6}>
        {/* Header */}
        <Flex mb={8} align="center" justify="space-between">
          <IconButton
            aria-label="Menu"
            icon={<FiMenu />}
            display={{ base: "flex", md: "none" }}
          />
          <Heading size="lg">Welcome, John!</Heading>
          <Avatar name="John Doe" />
        </Flex>

        {/* Upcoming Ride */}
        <Box
          bg="white"
          p={6}
          borderRadius="lg"
          boxShadow="md"
          mb={8}
        >
          <Heading size="md" mb={2}>
            Upcoming Ride
          </Heading>
          <Text fontSize="lg" mb={1}>From: Downtown</Text>
          <Text fontSize="lg" mb={1}>To: Airport</Text>
          <Text fontSize="md" color="gray.500">Pickup: 4:00 PM • April 20, 2025</Text>
          <Button mt={4} colorScheme="teal">
            View Details
          </Button>
        </Box>

        {/* Ride History */}
        <Box>
          <Heading size="md" mb={4}>Ride History</Heading>
          <VStack spacing={4} align="stretch">
            {["City Center to Mall", "Station to Office", "Home to Gym"].map((ride, i) => (
              <Box
                key={i}
                p={4}
                bg="white"
                borderRadius="md"
                shadow="sm"
              >
                <Text fontWeight="bold">{ride}</Text>
                <Text fontSize="sm" color="gray.500">
                  Date: April {10 + i}, 2025 • Time: {2 + i}:00 PM
                </Text>
              </Box>
            ))}
          </VStack>
        </Box>
      </Box>
    </Flex>

    </CustomerLayout>
  );
};

export default UserDashboard;
